"use strict";

import angular from "angular";

import loaderDialogTemplate from "./loader-dialog.html";
import "./loader-dialog.scss";

export class LoaderService {
    constructor($mdDialog) {
        this.$mdDialog = $mdDialog;
        this.progress = false;
    }

    open(ev = {}) {
        this.$mdDialog
            .show({
                controller: "LoaderDialogCtrl",
                template: loaderDialogTemplate,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                escapeToClose: false
            })
            .then(
                (answer) => {},
                () => {}
            );
    }

    close() {
        this.$mdDialog.hide();
    }

    setProgress(status = true) {
        this.progress = status;
    }
}

angular.module("nucont.shared").service("LoaderService", ["$mdDialog", LoaderService]);
